var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.ClassObject},[(_vm.rowValue != 0)?_c('p',{staticStyle:{"cursor":"pointer"},attrs:{"plain":""},on:{"click":function($event){return _vm.onClicked(_vm.column, _vm.row)}}},[_vm._v(" "+_vm._s(_vm.formatterMoney(_vm.rowValue))+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }